import {
  WSActions,
  WSCard,
  WSElement,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { ProgressBar } from "../../../../MemberOnboarding/components/ProgressBar/ProgressBar";
import { EditPayeeSetupParams } from "./index";
import { SetupRouteComponentProps } from "../../../../shared/components/FlowSetup";
import React, { useCallback, useEffect } from "react";
import {
  ComplianceEntityType,
  VerificationLaneStatus
} from "@wingspanhq/wingspan-api-sdk";
import { useQueryContractorComplianceEntity } from "../../hooks/useContractorTaxCompliance";
import { selectorComplianceEntityTaxLaneStatus } from "../../selectors/selectorComplianceEntityTaxLaneStatus";

type Props = SetupRouteComponentProps<EditPayeeSetupParams>;

export const EditPayeeTaxInfoVerification: React.FC<Props> = ({
  onNext,
  params
}) => {
  const payeeId = params?.payeeId;
  const isBusiness =
    params?.complianceEntity?.type === ComplianceEntityType.BUSINESS;

  const queryComplianceEntity = useQueryContractorComplianceEntity(payeeId);

  useEffect(() => {
    const interval = setInterval(async () => {
      const { data } = await queryComplianceEntity.refetch();
      const status = selectorComplianceEntityTaxLaneStatus(data);

      if (status === VerificationLaneStatus.VERIFIED) {
        onNext({ status: "Verified" });
      } else if (status === VerificationLaneStatus.FAILED) {
        onNext({ status: "Failed" });
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [onNext, queryComplianceEntity]);

  const onComplete = useCallback(() => {
    onNext({ status: "Pending" });
  }, [onNext]);

  const tinTypeLabel = isBusiness
    ? "Employer Identification Number (EIN)"
    : "Social Security Number (SSN)";

  return (
    <WSList gap="2XL">
      <WSCard header={`Verifying contractor’s ${tinTypeLabel}`}>
        <WSElement>
          <ProgressBar mb="XL" ms={20000} onComplete={onComplete} />

          <WSInfoBox mb="M">
            We are verifying the contractor’s {tinTypeLabel} with the IRS. This
            can take up to 10 seconds.
          </WSInfoBox>
        </WSElement>
      </WSCard>
      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            disabled: true
          }
        ]}
      />
    </WSList>
  );
};
